import BasicModel from '../basic/BasicModel'
export default {
  deleteNavigation (vm, params, listener) {
    let action = 'icon/deleteNavigation.action'
    BasicModel.post(vm, action, params, listener)
  },
  changeNavigationStatus (vm, params, listener) {
    let action = 'icon/changeNavigationStatus.action'
    BasicModel.post(vm, action, params, listener)
  },
  deleteCarCircle (vm, params, listener) {
    let action = 'icon/deleteCarCircle.action'
    BasicModel.post(vm, action, params, listener)
  },
  changeCarCircleStatus (vm, params, listener) {
    let action = 'icon/changeCarCircleStatus.action'
    BasicModel.post(vm, action, params, listener)
  },
  updateChannelStyleType (vm, params, listener) {
    let action = 'icon/updateChannelStyleType.action'
    BasicModel.post(vm, action, params, listener)
  }

}
